import React from 'react'

export default function OpacityFilterTop() {
  return (
    <div className="w-full h-20 sm:h-[100px] bg-gradient-to-b from-black/50 via-black/30 to-transparent fixed top-0 left-0 z-[90]"></div>
  )
}
